import { render, staticRenderFns } from "./StudentLoanThresholds.vue?vue&type=template&id=8ffab18c&scoped=true&"
import script from "./StudentLoanThresholds.vue?vue&type=script&lang=js&"
export * from "./StudentLoanThresholds.vue?vue&type=script&lang=js&"
import style0 from "./StudentLoanThresholds.vue?vue&type=style&index=0&id=8ffab18c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ffab18c",
  null
  
)

export default component.exports